import L from 'leaflet';

// Import icons
import kekCsik from '../Assets/Turistaútjelzések/kék csík.png';
import kekHaromszog from '../Assets/Turistaútjelzések/kék háromszög.png';
import kekKereszt from '../Assets/Turistaútjelzések/kék kereszt.png';
import kekPont from '../Assets/Turistaútjelzések/kék pont.png';
import pirosCsik from '../Assets/Turistaútjelzések/piros csík.png';
import pirosHaromszog from '../Assets/Turistaútjelzések/piros háromszög.png';
import pirosKereszt from '../Assets/Turistaútjelzések/piros kereszt.png';
import pirosPont from '../Assets/Turistaútjelzések/piros pont.png';
import sargaCsik from '../Assets/Turistaútjelzések/sárga csík.png';
import sargaHaromszog from '../Assets/Turistaútjelzések/sárga háromszög.png';
import sargaKereszt from '../Assets/Turistaútjelzések/sárga kereszt.png';
import sargaPont from '../Assets/Turistaútjelzések/sárga pont.png';
import viaMariae from '../Assets/Turistaútjelzések/via mariae.png';
import viaTransilvanica from '../Assets/Turistaútjelzések/via transilvanica.png';
import kekBicikli from '../Assets/kék bicikli.png';
import pirosBicikli from '../Assets/piros bicikli.png';

export const markIcons = {
    'kék csík': kekCsik,
    'kék háromszög': kekHaromszog,
    'kék kereszt': kekKereszt,
    'kék pont': kekPont,
    'piros csík': pirosCsik,
    'piros háromszög': pirosHaromszog,
    'piros kereszt': pirosKereszt,
    'piros pont': pirosPont,
    'sárga csík': sargaCsik,
    'sárga háromszög': sargaHaromszog,
    'sárga kereszt': sargaKereszt,
    'sárga pont': sargaPont,
    'via mariae': viaMariae,
    'via transilvanica': viaTransilvanica,
    'm': viaMariae,
    't': viaTransilvanica,
    'M': viaMariae,
    'T': viaTransilvanica,
    'via mariae.png': viaMariae,
    'via transilvanica.png': viaTransilvanica,
    'kék bicikli': kekBicikli,
    'piros bicikli': pirosBicikli,
    'kék bicikli.png': kekBicikli,
    'piros bicikli.png': pirosBicikli,
};

export const getMarkIcon = (markName, zoom = 13, isMobile = false) => {
    if (!markName) return null;
    const key = markName.toLowerCase().trim();
    const iconUrl = markIcons[key] || markIcons[markName.trim()]; // Try case-insensitive then exact match
    if (!iconUrl) return null;
    
    // Dinamikus méretezés a zoom szint alapján
    let size = Math.max(12, Math.min(24, zoom * 1.5));
    if (isMobile) size = size * 1.2;
    
    // M és T ikonok nagyobbak legyenek, mert ritkábban látszanak és fontos utak
    if (key === 'm' || key === 't' || key === 'via mariae' || key === 'via transilvanica') {
        size = size * 1.8;
    }
    
    return new L.Icon({
        iconUrl: iconUrl,
        iconSize: [size, size],
        iconAnchor: [size / 2, size / 2],
    });
};

export const getRouteColor = (markName) => {
    if (!markName) return '#d32f2f'; // Alapértelmezett piros
    const name = markName.toLowerCase().trim();
    if (name.includes('piros')) return '#d32f2f';
    if (name.includes('kék')) return '#1976d2';
    if (name.includes('sárga')) return '#fbc02d';
    if (name.includes('via mariae') || name === 'm') return '#800080'; // Lila
    if (name.includes('via transilvanica') || name === 't') return '#ff9800'; // Narancs
    return '#d32f2f';
};

// Segédfüggvény több pont kiszámításához az útvonal mentén
export const getPointsAlongPath = (multiPositions, zoom, markName = '') => {
    // Biztosítjuk, hogy tömbök tömbje legyen (MultiLineString-szerű felépítés)
    const segments = Array.isArray(multiPositions[0][0]) ? multiPositions : [multiPositions];
    const allPoints = [];

    // Zoom alapú sűrűség: a cél a "pixelsűrűség" megtartása
    let baseDensity = Math.pow(1.5, zoom - 8) * 0.025;

    // Via Transilvanica (T) esetén sűrűbb ikonelhelyezés
    const name = markName.toLowerCase().trim();
    if (name === 't' || name === 'via transilvanica') {
        baseDensity = baseDensity * 2.0;
    }

    // Távolság számítása két pont között (egyszerűsített Pitagorasz)
    const getDist = (p1, p2) => {
        const dx = p1[0] - p2[0];
        const dy = p1[1] - p2[1];
        return Math.sqrt(dx * dx + dy * dy);
    };

    // 1. Kiszámítjuk a teljes hosszt az összes szegmensre
    let totalRouteDist = 0;
    const segmentsData = segments.map(positions => {
        if (!positions || positions.length < 2) return { positions: [], dist: 0, partialDists: [] };
        
        let segmentDist = 0;
        const partialDists = [0];
        for (let i = 0; i < positions.length - 1; i++) {
            const d = getDist(positions[i], positions[i + 1]);
            segmentDist += d;
            partialDists.push(segmentDist);
        }
        totalRouteDist += segmentDist;
        return { positions, dist: segmentDist, partialDists };
    }).filter(s => s.dist > 0);

    if (totalRouteDist === 0) return [];

    // 2. Meghatározzuk az ikonok összegét a teljes útra
    // totalRouteDist koordináta egységben van, a 100-as szorzó az érzékenységhez kell
    let totalIconCount = Math.floor(baseDensity * (totalRouteDist * 100));

    // Hosszú útvonalaknál a pontok száma alapján is korrigálunk (globálisan)
    const totalPoints = segments.reduce((sum, p) => sum + (p ? p.length : 0), 0);
    if (totalPoints > 100) {
        const minIconsByPoints = (Math.floor(totalPoints / 2000)) * (zoom / 15);
        totalIconCount = Math.max(totalIconCount, Math.floor(minIconsByPoints));
    }

    if (totalIconCount < 1) return [];

    // 3. Elosztjuk az ikonokat a szegmensek között a hosszuk alapján
    segmentsData.forEach(segment => {
        const segmentIconCount = Math.round((segment.dist / totalRouteDist) * totalIconCount);
        if (segmentIconCount < 1) return;

        const stepDist = segment.dist / (segmentIconCount + 1);
        let currentPosIndex = 0;

        for (let i = 1; i <= segmentIconCount; i++) {
            const targetDist = i * stepDist;
            
            while (currentPosIndex < segment.partialDists.length - 1 && segment.partialDists[currentPosIndex + 1] < targetDist) {
                currentPosIndex++;
            }

            const p1 = segment.positions[currentPosIndex];
            const p2 = segment.positions[currentPosIndex + 1];
            if (p1 && p2) {
                const segmentStartDist = segment.partialDists[currentPosIndex];
                const segmentEndDist = segment.partialDists[currentPosIndex + 1];
                const segmentLen = segmentEndDist - segmentStartDist;
                
                if (segmentLen > 0) {
                    const ratio = (targetDist - segmentStartDist) / segmentLen;
                    const interpolatedPoint = [
                        p1[0] + (p2[0] - p1[0]) * ratio,
                        p1[1] + (p2[1] - p1[1]) * ratio
                    ];
                    allPoints.push(interpolatedPoint);
                } else {
                    allPoints.push(p1);
                }
            }
        }
    });

    return allPoints;
};
